namespace GeniuzPOS.Lookups {
    export interface VwSupplItemRow {
        SupplItemCode?: string;
    }

    export namespace VwSupplItemRow {
        export const idProperty = 'SupplItemCode';
        export const nameProperty = 'SupplItemCode';
        export const localTextPrefix = 'Lookups.VwSupplItem';
        export const lookupKey = 'Lookups.VwSupplItem';

        export function getLookup(): Q.Lookup<VwSupplItemRow> {
            return Q.getLookup<VwSupplItemRow>('Lookups.VwSupplItem');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SupplItemCode = "SupplItemCode"
        }
    }
}
